import { trace } from "firebase/performance";
import { performanceMonitoring } from "../../../firebase";

const MAX_ATTRIBUTE_LENGTH = 100;

export function getRaceSizeBucket(documentCount) {
  const count = Math.max(0, Number(documentCount) || 0);
  if (count <= 50) return "0_50";
  if (count <= 100) return "51_100";
  if (count <= 250) return "101_250";
  if (count <= 500) return "251_500";
  return "501_plus";
}

export function getUtf8ByteLength(value) {
  const text = String(value || "");
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(text).length;
  }
  return unescape(encodeURIComponent(text)).length;
}

function normalizeAttribute(value) {
  return String(value ?? "unknown").slice(0, MAX_ATTRIBUTE_LENGTH);
}

function normalizeMetric(value) {
  const metric = Number(value);
  return Number.isFinite(metric) ? Math.max(0, Math.round(metric)) : 0;
}

function createSafeTrace(name, initialAttributes = {}) {
  let firebaseTrace = null;
  let stopped = false;

  try {
    firebaseTrace = trace(performanceMonitoring, name);
    Object.entries(initialAttributes).forEach(([key, value]) => {
      firebaseTrace.putAttribute(key, normalizeAttribute(value));
    });
    firebaseTrace.start();
  } catch (error) {
    console.warn(`Unable to start Firebase Performance trace ${name}`, error);
  }

  return {
    putAttribute(key, value) {
      if (!firebaseTrace || stopped) return;
      try {
        firebaseTrace.putAttribute(key, normalizeAttribute(value));
      } catch (error) {
        console.warn(`Unable to add attribute ${key} to ${name}`, error);
      }
    },
    putMetric(key, value) {
      if (!firebaseTrace || stopped) return;
      try {
        firebaseTrace.putMetric(key, normalizeMetric(value));
      } catch (error) {
        console.warn(`Unable to add metric ${key} to ${name}`, error);
      }
    },
    stop(result = "success") {
      if (!firebaseTrace || stopped) return;
      stopped = true;
      try {
        firebaseTrace.putAttribute("result", normalizeAttribute(result));
        firebaseTrace.stop();
      } catch (error) {
        console.warn(`Unable to stop Firebase Performance trace ${name}`, error);
      }
    },
  };
}

export function startLeaderboardLoadTrace({ raceId, dataSource = "legacy" }) {
  return createSafeTrace("leaderboard_initial_load", {
    race_id: raceId,
    data_source: dataSource,
    has_map: "unknown",
    race_size: "unknown",
  });
}

export function startLeaderboardMapTrace({ raceId, dataSource = "legacy" }) {
  return createSafeTrace("leaderboard_map_load", {
    race_id: raceId,
    data_source: dataSource,
  });
}
